// SidePanelHeader.tsx

import { Typography, Box, Stack } from '@mui/material'
import React from 'react'

import ExportButton from './ExportButton'
import ResetFiltersButton from './ResetFiltersButton'

export interface ISidePanelHeaderProps {
  actions?: React.ReactNode
  information?: string
  onExport?: () => void
  onReset?: () => void
  subtitle?: string
  title?: string
}

const SidePanelHeader = (props: ISidePanelHeaderProps) => {
  const { title, subtitle, information, actions, onExport } = props

  return (
    <Stack
      gap={4}
      sx={{
        px: '12px',
        pt: '24px',
        pb: '8px',
        mb: 1,
        borderBottom: 'solid 1px',
        borderBottomColor: 'divider',
      }}
    >
      <Stack direction="row">
        <Box display="flex" flexDirection="column" flex="1">
          <Box display="flex" alignItems="center">
            <Typography variant="h5" sx={{ mb: 1 }}>
              {title}
            </Typography>
          </Box>

          <Typography variant="h6">{subtitle}</Typography>

          <Typography display="inline" variant="subtitle2">
            {information}
          </Typography>
        </Box>
        <Stack flexDirection="row" height="28px" gap={1}>
          {props.onReset && <ResetFiltersButton onReset={props.onReset} />}

          {onExport && <ExportButton onExport={onExport} sx={{ height: '28px' }} />}
        </Stack>
      </Stack>

      <Stack gap={1}>{actions}</Stack>
    </Stack>
  )
}

export default SidePanelHeader
